import React, { useRef, useState } from "react";
import * as PropTypes from "prop-types";
import { reportingYear } from "../../../constants";
import { formatValue } from "../../../utilities";
import AbsoluteChartToggleFrame from "../../widgets/AbsoluteChartToggleFrame";
import MethodMixChart from "../charts/MethodMixChart";
import ItemChooser from "../../choosers/ItemChooser";

const MethodMixWithinSectorChartWidget = props => {
  const [sectorId, setSectorId] = useState(3);

  const ref = useRef();

  return (
    <AbsoluteChartToggleFrame
      dataViewerId="method_mix_within_sector_chart"
      reference="Figure 2.3"
      title={`Method Mix within ${props.database.sectors[sectorId]} Sector, ${reportingYear}`}
      subtitle="Comparison by GNI Group"
      contentWidth={350}
      filters={[
        <ItemChooser
          id="figure-2-3"
          label="Select Sector"
          items={[
            {
              value: "3",
              label: "Private"
            },
            {
              value: "6",
              label: "Public"
            },
            {
              value: "-1",
              label: "Total"
            }
          ]}
          value={(sectorId || -1).toString()}
          onChange={value => {
            value = value === "-1" ? undefined : parseInt(value, 10);

            setSectorId(value);

            props.onChange({
              widget: "theme2.methodMixWithinSectorChart",
              payload: {
                sectorId: value
              }
            });
          }}
        />
      ]}
      initialAbsolute={false}
      chartRef={ref}
      chartSettings={{
        sector: sectorId ? props.database.sectors[sectorId] : "All"
      }}
    >
      <MethodMixChart
        ref={ref}
        data={props.data}
        tooltipFormatter={function() {
          return `${this.series.name} Users in ${
            this.key
          }: <strong>${formatValue(this.y)}</strong><br />Share of ${
            this.key
          } Users: <strong>${formatValue(
            this.percentage / 100,
            true
          )}</strong>`;
        }}
      />
    </AbsoluteChartToggleFrame>
  );
};

MethodMixWithinSectorChartWidget.propTypes = {
  data: PropTypes.array.isRequired,
  onChange: PropTypes.func.isRequired
};

export default MethodMixWithinSectorChartWidget;
